import React from "react";
import "./About.scss";

import { motion } from "framer-motion";
import { bios } from "../../../Data";
import portfolio from "../../../assets/portfolio.jpg";
import CvFile from "../../../assets//cv.pdf";
const About = () => {
  return (
    <div className="container " id="about">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ y: [-50, 0], opacity: 1 }}
        className="title"
      >
        <span>Who Am I?</span>
        <h1>About Me</h1>
      </motion.div>

      <div className="about_container">
        <motion.div
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [-250, 0], opacity: 1 }}
          transition={{ duration: 1 }}
          className="about_left"
        >
          <motion.img
            src={portfolio}
            whileHover={{ y: -48, x: -55 }}
            transition={{ duration: 0.3 }}
          />
        </motion.div>
        <motion.div
          className="about_right"
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [250, 0], opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <p>
            Hi, I’m Bhavik Gevariya, a software developer with 4 years of
            experience specializing in JavaScript, React.js, Node.js, Java, and
            Python. I’ve led impactful projects, including an NPS survey system
            that enhanced customer engagement and an award-winning ESG reporting
            tool. My educational journey includes a Bachelor’s in Computer
            Engineering and a Master’s in Applied Computing.{" "}
          </p>
          <p>
            {" "}
            I bring a strong technical foundation with expertise in SQL,
            MariaDB, PostgreSQL, MongoDB, Sequelize, Prisma, GraphQL, Docker,
            Jenkins, AWS, and Linux. At V2 Web Solutions and Belymon Infotech, I
            focused on optimizing database performance, reducing query times,
            and implementing CI/CD pipelines to streamline development
            processes. My experience also spans React Native, Angular, Vue.js,
            Tailwind CSS, and various development tools like Git and Jira.
          </p>
          <p>
            {" "}
            Driven by a passion for solving complex problems and fostering
            innovation, I’m always excited to connect with professionals and
            explore new opportunities. Let’s connect to discuss technology,
            projects, and potential collaborations!
          </p>

          {bios.map((bio) => {
            return (
              <div className="bio" key={bio.id}>
                <span className="bioKey">
                  {bio.icon}
                  {bio.key}
                </span>
                <span className="bioValue">{bio.value}</span>
              </div>
            );
          })}
          {/* <motion.a
            href={CvFile}
            download
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.3 }}
          >
            Download Resume
          </motion.a> */}
        </motion.div>
      </div>
    </div>
  );
};

export default About;
